<!-- компонент App: главный компонент приложения -->
<template>

	<div id="app" :key="appKey">
	<template v-if="loading">
		<div class="ajax-backdrop-loader">
			<img :src="stylePathToLoader || '/static/img/loader.gif'" /><span>{{ $store.state.lang === 'en' ? 'Authentication check...' : 'Проверка аутентификации...' }}</span>
		</div>
	</template>

	<template v-else>
		<errorPage v-if="errorMessage !== false" :message="errorMessage" :code="errorCode"></errorPage>
		<template v-else>
			<!-- страницы без интерфейса перечисляем здесь -->
			<workBoard v-if="$store.state.is_auth === true && $route.path.indexOf('/unsubscribe') !== 0 && $route.path !== '/503' && $route.path !== '/user/check' && $route.path !== '/email/check'" />
			<operationPage v-else-if="!$store.state.is_auth && ($route.path.indexOf('/operation/select/') === 0 || $route.path.indexOf('/operation/pay/') === 0 || $route.path.indexOf('/operation/view/') === 0 || $route.path === '/operation/list')" />
			<unauthPage v-else />
			<!-- переключатель языка -->
			<Lang v-if="$store.state.is_auth !== true &&
				(
					$route.path.indexOf('/unsubscribe') === 0 ||
					$route.path === '/503' ||
					$route.path === '/user/check' ||
					$route.path === '/email/check' ||
					$route.path === '/operation/list' ||
					$route.path === '/login' ||
					$route.path === '/register' ||
					$route.path === '/forget' ||
					$route.path.indexOf('/operation/select/') === 0 ||
					$route.path.indexOf('/operation/pay/') === 0 ||
					$route.path.indexOf('/operation/view/') === 0
				)" :fixed="true" />
		</template>	
	</template>

	<!-- Блок долгой загрузки -->
	<div v-show="this.$store.state.longRequest" class="ajax-backdrop-loader"><img :src="stylePathToLoader || '/static/img/loader.gif'" /><span>{{ 'main/loading' | ftc }}</span></div>

	<!-- Блок новой версии -->
	<!-- кнопка -->
	<div v-show="showUpdatePanelButton" class="w5-cp-update-button">
		<div class="w5-pulse-inner" @click="showUpdateBlock"></div>
		<div class="w5-pulse-outter"></div>
	</div>
	<!-- сам блок -->
	<div v-show="showUpdatePanelMessageBlock" class="w5-cp-update-warning alert alert-warning">
		{{ messagesForUpdateBlock[0] }}
		<span @click="reloadApp">{{ messagesForUpdateBlock[1] }}</span>
	</div>

	<!-- блок заблокированного приложения -->
	<div v-show="this.$store.state.applicationBlocked" class="modal-mask">
		<div class="modal-wrapper">
			<div class="modal-container" @click.stop>

					<div class="modal-header font-weight-500">{{ 'main/refresh_screen' | ftc }}</div>

					<div class="modal-body">
						<img v-if="AppName === 'vdsina' || AppName === 'vdsina.com'" src="./assets/img/idle.png" align="left" style="width: 40px; margin-right: 10px;" />
						<img v-else-if="AppName === 'macloud'" src="./assets/img/idle-mc.png" align="left" style="width: 40px; margin-right: 10px;" />
						<p style="margin: 0">{{ 'main/user_idle_state_text' | ftc }}</p>
					</div>

					<div class="modal-footer">
						<span class="btn btn-submit btn-submit-small pull-right" @click.stop="reloadApp">{{ 'main/update' | ftc }}</span>
					</div>

			</div>
		</div>
	</div>

	<!-- блок предупреждений для клиента -->
	<div v-if="clientWarnings && clientWarnings.length && clientWarnings[0].subject && clientWarnings[0].content" class="modal-mask">
		<div class="modal-wrapper warnings">
			<div class="modal-container warnings" @click.stop>

					<div class="modal-header font-weight-500">{{ clientWarnings[0].subject | ftc }}</div>

					<div class="modal-body">
						<p v-if="clientWarnings[0].content_type === 'html'" style="margin: 0" v-html="clientWarnings[0].content"></p>
						<p v-else style="margin: 0" v-formatTicketMessage="{
							'message': {
								message_content_type: clientWarnings[0].content_type,
								message_content: clientWarnings[0].content
							},
							'fastSearchValue': null
						}"></p>
					</div>

					<div class="modal-footer">
						<span class="w5-field close-client-warning pull-left">
							<input id="closeClientWarning" type="checkbox" class="w5-checkbox-field"
							v-model="clientWarningsCloseValue">
							<label for="closeClientWarning">{{ 'main/never_show' | ftc }}</label>
						</span>
						<span class="btn btn-submit-danger btn-submut pull-right btn-warn" @click.stop="closeWarning">{{ 'main/close' | ftc }}</span>
						<span class="btn btn-submit btn-submut pull-right btn-warn" @click.stop="gotoWarningTicket">{{ 'ticket/ticket' | ftc }}</span>
					</div>

			</div>
		</div>
	</div>

	<!-- блок смены пароля и подтверждения email -->
	<div v-if="$store.state.is_auth === true && $route.path.indexOf('/unsubscribe') !== 0 && $route.path !== '/503' && $route.path !== '/user/check' && $route.path !== '/email/check'"
		v-show="showUserNeedDialogModal"
		class="modal-mask">
		<div class="modal-wrapper">
			<div class="modal-container" @click.stop>
				<!-- заголовок -->
				<div class="modal-header">
					<span class="font-weight-500">{{ userNeedDialogTitle | ftc }}</span>
					<button type="button" class="close" @click="hideUserNeedDialogModal">&times;</button>
				</div>
				<!-- тело диалога -->
				<div v-if="fieldsUserNeed && fieldsUserNeed.fields" class="modal-body">
					<p>{{ userNeedDialogMode === 'password' ? 'user/need_password_change' : 'user/need_email_confirm' | ftc }}</p>
					<template v-if="userNeedDialogMode === 'password'">
						<div v-for="(row, index) in fieldsUserNeed.fields" v-if="row" :key="index" :class="{ 'w5-form-row v-center': isVisibleField(row) }">
							<template v-for="field in row">
								<Field
									:key="field._field_name"
									:isVisibleRow="isVisibleField(row)"
									:fieldInModal="true"
									:removeRightPadding="true"
									crud="userneed"
									action="update"
									:Field="field"
									v-model="field.value"
									@blur="onBlurInput(field)"
									@focus="onFocusInput(field)"
									@enterKeyDown="submitUserNeedForm" />
							</template>
						</div>
					</template>
					<div v-else
						v-show="fieldEmailError"
						class="alert alert-danger w5-alert-valid email-create"
						role="alert"
						v-withSafeTags="localeFtc(fieldEmailError)" />
				</div>
				<!-- подвал -->
				<div class="modal-footer">
					<span class="btn btn-submit" @click="submitUserNeedForm">{{ userNeedDialogMode === 'password' ? 'main/continue' : 'main/confirm' | ftc }}</span>
				</div>
			</div>
		</div>
	</div>

	<!-- стрелки скроллов для модальных диалогов -->
	<font-awesome-icon id="modal-scroll-arrow-up" icon="long-arrow-alt-up" class="modal-scroll-arrow" />
	<font-awesome-icon id="modal-scroll-arrow-down" icon="long-arrow-alt-down" class="modal-scroll-arrow" />

	<!-- блок системы нотификаций -->
	<Notificator />

	<!-- определения ретины -->
	<span id="for-retina-detection"></span>

	<!-- звук блокировки приложения -->
	<audio src="/static/snd/block.mp3" ref="audioBlock" />

	<!-- версия приложения и АПИ для сотрудников -->
	<div v-if="$store.state.user_type === 'admin'" class="w5-version-info">
		{{ clVersion }}
		<br/>
		{{ this.$store.state.apiVersion }}
	</div>
	</div>

</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Vue from 'vue'
import $ from 'jquery'
import debounce from 'debounce'
import workBoard from '@/components/workBoard'
import unauthPage from '@/components/unauthPage'
import operationPage from '@/components/operationPage'
import errorPage from '@/components/errorPage'
import Notificator from '@/components/widgets/notificator'
import Helper from '@/helper/helper'
import { EventBus } from './bus.js'
import Field from '@/components/elements/formfield'
import Lang from '@/components/elements/lang'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование компонента
	//=========================================================================
	name: 'app',
	//=========================================================================
	// локальные переменные компонента
	//=========================================================================
	data: function() {
		return {
			loading: true,
			errorMessage: false,
			errorCode: 0,
			workerVersion: false,
			workerPush: false,
			workerCron: false,
			showUpdatePanelButton: false,
			showUpdatePanelMessageBlock: false,

			messagesForUpdateBlock: [],

			idleTimer: null,
			idleEventsCount: 0,

			Referrer: false,

			appKey: 0,

			// ссылка на элемент "audio"
			audio: null,
			canPlay: false,

			// клавиши контроля скроллом
			// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36, left: 37, up: 38, right: 39, down: 40,
			keys: {
				32: 'spacebar',
				33: 'pageup',
				34: 'pagedown',
				35: 'end',
				36: 'home',
				37: 'left',
				38: 'up',
				39: 'right',
				40: 'down'
			},
			keysText: {
				33: 'pageup',
				34: 'pagedown'
			},

			// предупреждения для клиентов
			clientWarningsCloseValue: false,
			clientWarnings: [],

			// формы требования к пользователю
			showUserNeedDialogModal: false,
			userNeedDialogMode: 'password',
			userNeedDialogTitle: '',
			fieldsUserNeed: null,
			fieldEmailError: '',

			// данные в виде FormData
			FD: false,
			FD_count: 0,

			// показывали ссылку отзыва или нет, по умолчанию считаем что "да"
			vdsinaRecallLinkShown: true,

			// таймер поиска тела активного модального диалога
			activeModalFindTimer: null,
			// счетчик - сколько уже ищем
			activeModalFindCounter: 0,

			// позиция скролла окна
			windowScrollTop: false
		}
	},
	//=========================================================================
	// список используемых напрямую компонентов
	//=========================================================================
	components: {
		workBoard,
		unauthPage,
		errorPage,
		Notificator,
		operationPage,
		Field,
		Lang
	},
	//=========================================================================
	// высичляемый переменные
	//=========================================================================
	computed: {
		clVersion() {
			return 'cl ' + Vue.AppVersion + (this.$store.state.isDebug ? ' dev' : ' prod')
		},
		pageTitle() {
			return this.$store.state.pageTitle
		}
	},
	//=========================================================================
	// локальные методы
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// обработчик ошибки
		//---------------------------------------------------------------------
		onErrorInitApp(data) {
			// отключим признак загрузки данных
			this.loading = false
			// обнулим код ошибки
			this.errorCode = 0

			// если данные не заданы - ошибка по умолчанию
			if (!data || !data['what'] || !data['data'])
			{
				this.errorMessage = 'error/app_internal'
				return
			}

			// если это ошибка получения словаря
			if (data['what'] === 'locale')
			{
				// получим данные об ошибке
				let _dataError = data['data']

				// есть ли ответ сервера
				if (_dataError && 'status' in _dataError && 'ok' in _dataError && 'url' in _dataError)
				{
					// если это было прерывание запроса пользователем
					if (_dataError.status === 0 && String(data['ok']) === 'false')
					{
						this.errorMessage = 'error/request_terminated'
						return
					}
					if (_dataError.status === 400)
					{
						// запоминаем URL, что бы к нему вернуться
						this.$store.commit('setReturnURL', this.$route.path)
						this.errorMessage = 'error/cookie'
						this.errorCode = 400
						return
					}
					// ошибки 401 403
					else if (_dataError.status === 401 || _dataError.status === 403)
					{
						// аутентификации может и не быть, но подстрахуемся
						this.$store.commit('dropAuth')
						// запоминаем URL, что бы к нему вернуться
						this.$store.commit('setReturnURL', this.$route.path)
						// остановим Push-систему
						this.$store.commit('pushStop')
						// редирект на форму логина
						this.$router.push('/login')
						return
					}
					// остальные ошибки - 404, 503 и тд
					else if (_dataError.status >= 400)
					{
						// запоминаем URL, что бы к нему вернуться
						this.$store.commit('setReturnURL', this.$route.path)
						this.errorMessage = this.formatRequestError(_dataError['body'])
						this.errorCode = _dataError['status']
						return
					}
				}

				// это общая ошибка
				this.errorMessage = 'error/app_internal'
				return
			}

			// если это ошибка проверки воркеров или хранилища
			if (data['what'] === 'workers' || data['what'] === 'storage')
			{
				this.errorMessage = data['data']
				return
			}

			// если это ошибка аутентификации
			if (data['what'] === 'auth')
			{
				// нет сохраненной аутентификации
				if (data['data'] === '1')
				{
					// на всякий случай подчистим данные
					this.$store.commit('dropAuth')

					// если страница не публичная
					if (!this.isPublicUrl(this.$route.path))
					{
						// запоминаем URL, что бы к нему вернуться
						this.$store.commit('setReturnURL', this.$route.path)
						// переход к логину
						this.$router.push('/login')
					}

					// если мы тут - значит страница и так не требует аутентификации
					// ничего не делаем

					// на этом все - ошибку должен соответствующий компонент вывести
					return
				}
				else if (data['data'] === '2')
				{
					// получим данные об ошибке
					let _dataError = data['dataError']

					// если это было прерывание запроса пользователем
					if (_dataError && 'status' in _dataError && 'ok' in _dataError && 'url' in _dataError)
					{
						// непонятнная ошибка, или пользователь прервал запрос
						if (_dataError['status'] === 0 && String(_dataError['ok']) === 'false')
						{
							this.errorMessage = 'error/request_terminated'
							return
						}
						// если это смена сессии (сессия протухла)
						if (_dataError['status'] === 200 && _dataError['ok'] === true &&
							'data' in _dataError && _dataError['data'] && 'status' in _dataError['data'] &&
							_dataError['data']['status'] === 'form')
						{
							// если страница не публичная
							if (!this.isPublicUrl(this.$route.path))
							{
								// аутентификации может и не быть, но подстрахуемся
								this.$store.commit('dropAuth')
								// запоминаем URL, что бы к нему вернуться
								this.$store.commit('setReturnURL', this.$route.path)
								// остановим Push-систему
								this.$store.commit('pushStop')
								// переход к логину
								this.$router.push('/login')
							}

							// если мы тут - значит страница и так не требует аутентификации
							// ничего не делаем

							// на этом все - ошибку должен соответствующий компонент вывести
							return
						}
						// ошибка 401 - тут ее не может быть по идее...
						else if (_dataError.status === 401)
						{
							/*
							// при авторизации произошла какая то ошибка
							// сбросим аутентификацию
							this.$store.commit('dropAuth')

							// если страница не публичная
							if (!this.isPublicUrl(this.$route.path))
							{
								// запоминаем URL, что бы к нему вернуться
								this.$store.commit('setReturnURL', this.$route.path)
								// переход к логину
								this.$router.push('/login')
								// на этом все
								return
							}
							*/
							// аутентификации может и не быть, но подстрахуемся
							this.$store.commit('dropAuth')
							// запоминаем URL, что бы к нему вернуться
							this.$store.commit('setReturnURL', this.$route.path)
							// остановим Push-систему
							this.$store.commit('pushStop')
							// переход к логину
							this.$router.push('/login')
							return
						}
						// ошибка 403
						else if (_dataError.status === 403)
						{
							// если это ошибка - "доступ запрещен к какому то ресурсу"
							if ((_dataError.data && _dataError.data.content && String(_dataError.data.content).indexOf('forbidden') > 0) ||
								!Helper.verifyPermissions(this.$store.state.user_role, this.$router.currentRoute))
							{
								// ничего не делаем - ошибку отрисует активный дочерний компонент
								return
							}

							// при авторизации произошла какая то ошибка
							// сбросим аутентификацию
							this.$store.commit('dropAuth')
							// если страница не публичная
							if (!this.isPublicUrl(this.$route.path))
							{
								// запоминаем URL, что бы к нему вернуться
								this.$store.commit('setReturnURL', this.$route.path)
							}

							// переход к логину в любом случае
							this.$router.push('/login')
							// на этом все
							return
						}
						// при ошибке 503
						else if (_dataError.status === 503)
						{
							// запоминаем URL, что бы к нему вернуться
							this.$store.commit('setReturnURL', window.location.pathname)
							// сохраним код ошибки
							this.$store.commit('errorHttpCode', 503)
							// редирект на страницу с текстом ошибки
							this.$router.push('/503')
							return
						}

						// остальные ошибки прсто выведутся на не авторизованной странице
					}
				}
			}

			// ошибка по умолчанию
			this.errorMessage = 'error/app_internal'
			return
		},
		//---------------------------------------------------------------------
		// событие общей шины - смена языка
		//---------------------------------------------------------------------
		handleLang(newLang) {
			if (this.$store.state.lang === newLang) return

			// если пользователь авторизован
			if (this.$store.state.is_auth === true)
			{
				// сохраним в настройки
				this.$http.post(Vue.APIServerUrl + '/option/set/locale', Helper.toFormData({ value: newLang }))
				.then(() => {
					// кука
					Helper.setCookie('ln', newLang, { 'expires': 60 * 60 * 24 * 365, 'domain': Vue.CookieDomain, 'path': '/' })
					// загрузим словарь с установкой нового языка
					this.getLocale(newLang)
				})
				.catch(() => {})
			}
			// если пользователь не авторизован
			else
			{
				// кука
				Helper.setCookie('ln', newLang, { 'expires': 60 * 60 * 24 * 365, 'domain': Vue.CookieDomain, 'path': '/' })
				// загрузим словарь с установкой нового языка
				this.getLocale(newLang)
			}
		},
		//---------------------------------------------------------------------
		// функция получает сетевой словарь текстовых меток, возвращает промис
		//---------------------------------------------------------------------
		getLocale(lang) {
			// создаем промис и возвращаем его
			return new Promise((resolve, reject) => {
				// если нужно обновить язык
				if (lang && lang !== this.$store.state.lang)
				{
					// установим новый язык
					this.$store.commit('setLang', lang)
					// кука
					Helper.setCookie('ln', lang, { 'expires': 60 * 60 * 24 * 365, 'domain': Vue.CookieDomain, 'path': '/' })
				}

				// URL словаря
				//let _url = this.APIServerUrl + '/text/all/locale.js?_=' + Vue.AppVersion
				//let _url = this.APIServerUrl + '/error/view/505'
				let _url = `${this.APIServerUrl}/text/all/${this.$store.state.lang}.js?_=${Vue.AppVersion}`

				// мы должны запросить словарь
				this.$http.get(_url).then(
					// если мы успешно получили словарь
					resGet => {
						// получаем ответ
						if (resGet && resGet['ok'] === true && resGet['status'] === 200 && resGet['body'])
						{
							let _js = document.createElement('script')
							_js.type = 'text/javascript'
							_js.innerHTML = resGet['body']
							document.body.appendChild(_js)
							// да - словарь загружен, устанавливаем его в глобальную переменную
							const _locale = window.locale()
							if (_locale)
							{
								// установим в приложении
								Vue.setLocaleBase(_locale, this.$store.state.lang)
								// сообщение о версии
								let _answer = this.localeFtc('main/interface_new_version').split('{link}')
								if (_answer[1]) _answer[1] = _answer[1].replace('{/link}', '')
								this.messagesForUpdateBlock = _answer
								// заголовок страницы
								document.title = this.localeFtc(this.pageTitle)
								// перерисовка всего приложения
								this.appKey++
							}

							// на этом все
							resolve(true)
						}
						else
						{
							reject({
								'what': 'locale',
								'data': resGet
							})
						}
					},
					// возникла какая то ошибка
					resGet => {
						reject({
							'what': 'locale',
							'data': resGet
						})
					}
				)
			})
		},
		//---------------------------------------------------------------------
		// функция стартует web-воркеры, возвращает промис
		//---------------------------------------------------------------------
		startWorkers() {
			return new Promise((resolve, reject) => {
				// доступны ли веб-воркеры?
				if (!window.Worker)
				{
					// нет - воркеры недоступны, ошибка
					return reject({
						'what': 'workers',
						'data': 'error/html5'
					})
				}

				// все ок, создадим
				this.workerVersion = new Worker('/static/js/worker-version.js?_=' + Vue.AppVersion)

				// определим обработчик
				this.workerVersion.onmessage = (e) => {
					// проверка
					if (!e || !e.data) return

					// если пришло сообщение о том что нужно заблокировать приложение
					if (e && e.data === 'applicationBlock')
					{
						// при этом у нас есть активные закачки
						if (this.$store.state.uploadFileCounter > 0)
						{
							// делаем сброс блокировщика - нельзя пока блокировать
							if (this.workerVersion)
								this.workerVersion.postMessage('dropBlockerX2')
							// а так же простой запрос к АПИ - для продления сессии пользователя
							// результат запроса не интересен
							let _url = this.APIServerUrl + (this.$store.state.user_type === 'admin' ? '/admin/index' : '')
							this.$http.get(_url)
						}
						else
						{
							// блокируем приложение
							this.blockApp()
						}

						// на этом все
						return
					}

					// если уже показан блок с сообщением - больше ничего не делаем
					if (this.showUpdatePanelMessageBlock) return

					// сверим версию
					this.showUpdatePanelButton = e.data !== Vue.AppVersion
				}

				// сразу стартуем Web Worker
				// он проверяет версию приложения на сервере
				// и активности пользователя
				this.workerVersion.postMessage('start')

				// воркер для задач в фоне
				this.workerCron = new Worker('/static/js/worker-cron.js?_=' + Vue.AppVersion + '_0')
				// определим обработчик
				this.workerCron.onmessage = (e) => {
					// проверка
					if (!e || !e.data) return
					// сразу шлем сообщение в общую шину событий
					EventBus.$emit('w5-cron-task-answer', e.data)
				}
				// сразу стартуем Web Worker
				this.workerCron.postMessage('start')

				// все ок
				resolve(true)
			})
		},
		//---------------------------------------------------------------------
		// функция инициализирует хранилище, возвращает промис
		//---------------------------------------------------------------------
		initStorage() {
			return new Promise((resolve, reject) => {
				try {
					// если нет поддержки хранилищ
					if (!window || !window.localStorage || !window.sessionStorage)
					{
						// нет - хранилища недоступны, нужно вывести ошибку
						return reject({
							'what': 'storage',
							'data': 'error/html5'
						})
					}
				}
				catch (e) {
					return reject({
						'what': 'storage',
						'data': 'error/html5'
					})
				}

				// все ок
				resolve(true)
			})
		},
		//---------------------------------------------------------------------
		// функция аутентифицирует пользователя, возвращает промис
		//---------------------------------------------------------------------
		authUser() {
			return new Promise((resolve, reject) => {
				// готовим объект запроса
				// делаем запрос с помощью jQuery, так как у нас в либе стоит интерсептор
				// и перехватывает ошибки, но нам нужны эти ошибки для анализа
				$.ajax({
					url: Vue.APIServerUrl + '/login',
					cache: false,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					}
				})
				.done(async data => {
					let _dt = data && typeof data === 'object' && 'status' in data ? data : false
					if (_dt && _dt['status'] === 'ok' && _dt['user'])
					{
						// загрузим словарь
						await this.getLocale(_dt['locale'])
						// все ок
						return resolve(_dt)
					}

					// загрузим словарь
					await this.getLocale()
					// запрос пришел с неверными данными
					return reject({
						'what': 'auth',
						'data': '2',
						'dataError': {
							'url': this.$route.path,
							'status': 200,
							'ok': true,
							'data': _dt
						}
					})
				})
				.fail(async (jqXHR, textStatus, errorThrown) => {
					// загрузим словарь
					await this.getLocale()
					// запрос пришел с ошибкой
					return reject({
						'what': 'auth',
						'data': '2',
						'dataError': {
							'url': this.$route.path,
							'status': jqXHR.status,
							'ok': false,
							'data': false
						}
					})
				})
			})
		},
		//---------------------------------------------------------------------
		// получение различных словарей - делаем с промисами,
		// так как нам нужно дождаться результата
		// так же идет запрос групп VDS
		//---------------------------------------------------------------------
		getDictionaries() {
			return new Promise((resolve, reject) => {
				// мы должны запросить горуппу VDS в любом случае
				let _url = this.APIServerUrl + '/service/list?search=group&type=vds'
				// делаем запрос
				this.$http.get(_url).then(
					// если мы успешно получили словарь
					resGet => {
						// получаем ответ
						if (resGet && resGet['ok'] === true && resGet['status'] === 200 && resGet['body'] &&
							typeof resGet['body'] === 'object' && resGet['body']['status'] === 'ok')
						{
							// разрешаем промис
							resolve(resGet['body'])
						}
						else
						{
							reject({
								'what': 'auth',
								'data': '2',
								'dataError': resGet
							})
						}
					},
					// возникла какая то ошибка
					resGet => {
						reject({
							'what': 'auth',
							'data': '2',
							'dataError': resGet
						})
					}
				)
			})
		},
		//---------------------------------------------------------------------
		// процедуры при успешном входе
		//---------------------------------------------------------------------
		async successLogin(data) {
			// установка данных аутентификации
			await this.$store.commit('setAuth', data)

			// если это сотрудник
			if (data['user']['user_type'] === 'admin')
			{
				// увеличим таймаут блокиратора
				this.workerVersion.postMessage('adminTimeout')
				// запрос отделов по тикетам для сотрудников
				this.$store.commit('getTicketDepartments')
				// если это сотрудник - запрос версии АПИ
				this.$store.dispatch('getApiVersion')
			}
			// если это клиент
			else
			{
				// запросим предупреждения для клиентов
				this.getClientWarnings()
			}

			// установка GA uid
			this.setGAUid()

			// требования к пользователю
			if (this.$store.state.user_need && typeof this.$store.state.user_need === 'object')
			{
				// сначала проверим - нужно ли показывать диалог смены пароля
				if (this.$store.state.user_need.password_change)
				{
					this.userNeedDialogMode = 'password'
					this.showUserNeedDialog()
				}
				// если пароль менять не нужно - проверим, может нужно подтвердить email
				else if (this.$store.state.user_need.email_confirm)
				{
					this.userNeedDialogMode = 'email'
					this.showUserNeedDialog()
				}
			}

			// уберем спинер
			this.loading = false

			// проверка версии в localStorage
			let _userId = data['user']['user_id']
			let _clientVersion = window.localStorage.getItem('w5_api_version_' + _userId)
			if (!_clientVersion || _clientVersion !== Vue.AppVersion)
			{
				// если версия не задана или не совпадает - сброс всех настроек
				this.clearSettings(_userId)
				// и запись версии по новой
				window.localStorage.setItem('w5_api_version_' + _userId, Vue.AppVersion)
			}

			// переадресация с неавторизованных страниц
			if (this.$route.path === '/login' ||
				this.$route.path === '/register' ||
				this.$route.path === '/forget' ||
				this.$route.path === '/user/forget')
			{
				// если есть сохраненный путь
				if (this.$store.state.returnURL)
				{
					// получим путь
					let _url = this.$store.state.returnURL
					// обнуляем URL в Vuex
					this.$store.commit('setReturnURL', false)
					// переходим по этому пути
					this.$router.push(_url)
				}
				// нет такого пути
				else
				{
					// проверим путь в хранилище сессии
					let _ru = window.sessionStorage.getItem('_ru')
					if (_ru)
					{
						// удалим - теперь не нужно
						window.sessionStorage.removeItem('_ru')

						// если при этом был запрос с неавторизованной страницы
						if (_ru !== '/login' &&
							_ru !== '/register' &&
							_ru !== '/forget' &&
							_ru !== '/user/forget')
							// переход по данному пути
							return this.$router.push(_ru)
					}

					// если ничего нет
					this.$router.push('/')
				}
			}
		},
		//---------------------------------------------------------------------
		// запрос предупреждения для клиентов
		//---------------------------------------------------------------------
		getClientWarnings() {
			// по умолчанию - нет предупреждений
			this.clientWarnings = []
			// и галочка не отмечена
			this.clientWarningsCloseValue = false

			// запрос
			let _url = this.APIServerUrl + '/ticket/list?additional=getWarnings'
			this.$http.get(_url)
			// интересует только положительный ответ
			.then(res => {
				// получаем ответ
				if (res && res['ok'] === true && res['status'] === 200 && res['body'] &&
					typeof res['body'] === 'object' && res['body']['status'] === 'ok' &&
					res['body']['result'] && res['body']['result'].length)
				{
					// копируем только те у кого read=false
					this.clientWarnings = res['body']['result'].filter(item => !item.read)

					// если есть предупреждения - ищем диалог
					this.activeModalFindCounter = 0
					this.$nextTick(() => this.findActiveModal())
				}
			})
			.catch(() => {})
		},
		//---------------------------------------------------------------------
		// закрытие предупреждения для клиента
		//---------------------------------------------------------------------
		closeWarning() {
			// запомним ID сообщения и флаг
			let messageId = null
			if (this.clientWarnings && this.clientWarnings.length && this.clientWarnings[0].message_id)
				messageId = this.clientWarnings[0].message_id

			let isRequest = this.clientWarningsCloseValue

			// сразу удаляем первый элемент
			this.clientWarnings.shift()
			// и обнуляем флаг
			this.clientWarningsCloseValue = false

			// сразу скроем все стрелки модального диалога
			$('.modal-scroll-arrow').hide()

			// если клиент проставил значение
			if (isRequest && messageId)
			{
				// делаем запрос
				let _url = this.APIServerUrl + '/ticketmessage/update/' + messageId + '?additional=setRead'
				this.$http.get(_url)
				.catch(() => {})
			}
		},
		//---------------------------------------------------------------------
		// переход в тикет предупреждения
		//---------------------------------------------------------------------
		gotoWarningTicket() {
			// сразу скроем все стрелки модального диалога
			$('.modal-scroll-arrow').hide()

			let _ticket = this.clientWarnings[0]
			this.clientWarnings = []
			if (_ticket && _ticket.ticket_id)
				this.$router.push('/ticket/view/' + _ticket.ticket_id)
		},
		//---------------------------------------------------------------------
		// запоминаем GA uid пользователя в АПИ
		//---------------------------------------------------------------------
		setGAUid() {
			if (window && window.ga)
			{
				let _this = this
				window.ga(function() {
					let trackers = window.ga.getAll()
					if (trackers && trackers.length)
					{
						let tracker = trackers[0]
						if (tracker && tracker.get)
						{
							let clientId = tracker.get('clientId')
							if (clientId)
								_this.$http.post(Vue.APIServerUrl + '/option/set/ga_uid', Helper.toFormData({ value: clientId }))
								.catch(() => {})
						}
					}
				})
			}
		},
		//---------------------------------------------------------------------
		// показывает/скрывает блок обновления
		//---------------------------------------------------------------------
		showUpdateBlock() {
			this.showUpdatePanelButton = !this.showUpdatePanelButton
			this.showUpdatePanelMessageBlock = !this.showUpdatePanelMessageBlock

			let _answer = this.localeFtc('main/interface_new_version').split('{link}')
			if (_answer[1]) _answer[1] = _answer[1].replace('{/link}', '')
			this.messagesForUpdateBlock = _answer
		},
		//---------------------------------------------------------------------
		// перегружает приложение
		//---------------------------------------------------------------------
		reloadApp() {
			location.reload(true)
		},
		//---------------------------------------------------------------------
		// полностью блокирует приложение
		//---------------------------------------------------------------------
		blockApp() {
			// удалим обработчик для проверки активности
			document.removeEventListener('mousemove', this.dropBlocker)
			document.removeEventListener('keydown', this.dropBlocker)
			document.removeEventListener('scroll', this.dropBlocker)

			// нужно обнулить таймер и счетчик
			if (this.idleTimer) clearTimeout(this.idleTimer)
			this.idleEventsCount = 0

			// закроем все нотификации
			EventBus.$emit('w5-notificator-remove-all')

			// шлем сообщение в общую шину событий
			EventBus.$emit('w5-block-application', true)
			// остановим Push-систему
			this.$store.commit('pushStop')
			// остановим worker проверки версии и активности
			this.workerVersion.postMessage('stop')
			this.workerVersion.postMessage('stopBlocker')
			this.workerCron.postMessage('stop')
			// устанавливаем флаг в Vuex
			this.$store.commit('blockApplication')
			// проиграем звук блокировки
			if (this.$store.state.user_type === 'admin' && this.canPlay) this.audio.play()
		},
		//---------------------------------------------------------------------
		// сбрасывает счетчик активности пользователя
		//---------------------------------------------------------------------
		dropBlocker(e) {
			// если приложение уже хаблокировано - ничего не делаем
			if (this.$store.state.applicationBlocked) return

			// если это нажатие клавиш
			if (e && e.type === 'keydown')
			{
				// если нажали ESC
				if (e.keyCode === 27 && this.showUserNeedDialogModal)
				{
					e.preventDefault()
					e.stopPropagation()
					e.stopImmediatePropagation()
				}
				// сразу нужно обнулить таймер
				if (this.idleTimer) clearTimeout(this.idleTimer)
				// и зарядить таймер по новой
				this.idleTimer = setTimeout(() => {
					this.idleEventsCount = 0
					if (this.workerVersion) this.workerVersion.postMessage('dropBlocker')
				}, 1000)

				return
			}

			// если это другие события - считаем пришедшие события
			this.idleEventsCount++

			// если таймер уже заряжен
			if (this.idleTimer)
			{
				// и при этом, если количество событий уже больше чем достаточно
				if (this.idleEventsCount > 50)
				{
					// нужно обнулить таймер и счетчик
					clearTimeout(this.idleTimer)
					this.idleEventsCount = 0
					// отправить команду сейчас
					if (this.workerVersion) this.workerVersion.postMessage('dropBlocker')
					// и зарядить таймер по новой
					this.idleTimer = setTimeout(() => {
						this.idleEventsCount = 0
						if (this.workerVersion) this.workerVersion.postMessage('dropBlocker')
					}, 1000)
				}
			}
			else
			{
				// нужно зарядить таймер
				this.idleTimer = setTimeout(() => {
					this.idleEventsCount = 0
					if (this.workerVersion) this.workerVersion.postMessage('dropBlocker')
				}, 1000)
			}
		},
		//---------------------------------------------------------------------
		// функции контроля скрола окна
		//---------------------------------------------------------------------
		_preventDefault(e) {
			e = e || window.event

			if (e && e.target && e.target.className &&
				(e.target.className.indexOf('scrollable') > -1 || e.target.className.indexOf('multiselect__') > -1))
			{
				return true
			}
			if (e && e.target && e.target.tagName.toLowerCase() === 'span')
			{
				if (e.target.parentNode &&
					(e.target.parentNode.className.indexOf('scrollable') > -1 || e.target.parentNode.className.indexOf('multiselect__') > -1))
				{
					return true
				}
			}

			if (e.preventDefault) e.preventDefault()
			e.returnValue = false
		},
		_preventDefaultForScrollKeys(e) {
			if (e.target.type === 'textarea' || e.target.type === 'text')
			{
				if (this.keysText[e.keyCode])
				{
					this._preventDefault(e)
					return false
				}
			}
			else if (this.keys[e.keyCode])
			{
				this._preventDefault(e)
				return false
			}
		},
		disableScroll() {
			if (!$('body').hasClass('with-active-modal'))
				this.windowScrollTop = $(window).scrollTop()

			let _nav = document.querySelector('nav.navbar-fixed-top')
			if (_nav) _nav.style.width = _nav.offsetWidth + 'px'
			document.body.style.width = document.body.offsetWidth + 'px'

			this.addClass(document.body, 'with-active-modal')

			// ищем тело диалога
			this.activeModalFindCounter = 0
			this.$nextTick(() => this.findActiveModal())
		},
		enableScroll() {
			// сразу скроем блоки с ошибкой
			$('div.w5-alert-valid').hide()
			// сразу скроем все стрелки
			$('.modal-scroll-arrow').hide()

			this.removeClass(document.body, 'with-active-modal')

			let _nav = document.querySelector('nav.navbar-fixed-top')
			if (_nav) _nav.style.width = 'auto'
			document.body.style.width = 'auto'

			if (this.windowScrollTop !== false)
			{
				$(window).scrollTop(this.windowScrollTop)
				this.windowScrollTop = false
			}
		},
		//---------------------------------------------------------------------
		// поиск тела активного модального диалога
		//---------------------------------------------------------------------
		findActiveModal() {
			// сразу чистим таймер
			if (this.activeModalFindTimer) clearTimeout(this.activeModalFindTimer)

			// проверяем счетчик - если не нашли за 3 секунды, значит не судьба
			if (this.activeModalFindCounter++ > 6)
				return

			// ищем бэкдроп активного диалога
			let $mask = $('div.modal-mask:visible')
			if (!$mask.length)
			{
				// еще не нашли - заряжаем таймер снова
				this.activeModalFindTimer = setTimeout(() => this.findActiveModal(), 500)
				return
			}

			// пересчет блоков полей
			EventBus.$emit('w5-recount-field-blocks')

			// если разрешение не то
			if (this.$store.state.windowWidth > 767) return

			// переустанавливаем размеры маски диалога - так как в мобильных
			// при скролле - адресная строка то исчезает, то появляется
			// соответственно меняется видимая область
			let vh = window.innerHeight * 0.01
			document.documentElement.style.setProperty('--vh', vh + 'px')

			// ищем тело диалога
			let $body = $mask.find('div.modal-body:first')
			if (!$body.length)
			{
				// еще не нашли - заряжаем таймер снова
				this.activeModalFindTimer = setTimeout(() => this.findActiveModal(), 500)
				return
			}

			// нашли
			let arrows = 0
			// если есть скролл
			if ($body[0].scrollHeight > $body[0].clientHeight)
			{
				// где рисовать стрелку - 1 up, 2 down, 3 up&down
				let delta = $body[0].scrollHeight - $body[0].clientHeight
				if ($body[0].scrollTop <= 0)
					arrows = 2
				else if ($body[0].scrollTop > 0 && $body[0].scrollTop < delta)
					arrows = 3
				else if ($body[0].scrollTop >= delta)
					arrows = 1

				// меняем коордианты стрелок
				let w = $body.width()
				let h = $body.height()
				let l = $body.offset().left
				let t = $body.offset().top

				$('#modal-scroll-arrow-up').css({ left: l + w + 15 + 'px', top: t + 3 + 'px' })
				$('#modal-scroll-arrow-down').css({ left: l + w + 15 + 'px', top: t + h + 30 - 15 + 'px' })

				// обработчик скролла
				$body.off('scroll').on('scroll', this.onModalBodyScroll)
			}

			if (arrows > 0)
			{
				// up
				if (arrows === 3 || arrows === 1)
					$('#modal-scroll-arrow-up').show()
				// down
				if (arrows === 3 || arrows === 2)
					$('#modal-scroll-arrow-down').show()
			}
		},
		//---------------------------------------------------------------------
		// сборс настроек текущего пользователя
		//---------------------------------------------------------------------
		clearSettings(userId) {
			// чистим настройки пользователя на АПИ-сервере
			// теперь чистим руками на бэке запросом в DB и только при изменениях
			// в фильтрах
			// this.$store.commit('clearUserOptionsOnServer')

			// чистим настройки пользователя в localStorage
			let _userId = userId
			if (!_userId) _userId = this.$store.state.user_id
			// только свои настройки
			let _reg = new RegExp('^w5_' + _userId, 'i')
			let _keys = []
			// ищем в LocalStorage
			for (let i = 0; i < localStorage.length; i++)
			{
				// текущий ключ
				let _key = localStorage.key(i)
				// это наша настройка
				if (_reg.test(_key)) _keys.push(_key)
			}
			// теперь удалим что нашли
			_keys.forEach(k => {
				localStorage.removeItem(k)
			})

			// чистим настройки пользователя в sessionStorage
			_keys = []
			// ищем в sessionStorage
			for (let i = 0; i < sessionStorage.length; i++)
			{
				// текущий ключ
				let _key = sessionStorage.key(i)
				// это наша настройка
				if (_reg.test(_key)) _keys.push(_key)
			}
			// теперь удалим что нашли
			_keys.forEach(k => {
				sessionStorage.removeItem(k)
			})
		},
		//---------------------------------------------------------------------
		// событие: можно проигрывать аудио
		//---------------------------------------------------------------------
		audioCanPlay() {
			this.canPlay = true
		},
		//---------------------------------------------------------------------
		// обработка Push-сообщений
		//---------------------------------------------------------------------
		pushMessageHandler(msg) {
			// только с сообщением и только клиенты
			if (!msg || this.$store.state.user_type === 'admin') return

			// разобъем сообщение на части
			let _parts = msg.split(' ')

			// нас здесь интересуют только пуши по тикетам
			if (!_parts || !_parts.length || _parts[1] !== 'ticket') return

			// если это изменение тикета
			if (_parts[0] === 'update')
			{
				// запросим предупреждения для клиентов
				this.getClientWarnings()
			}
		},
		//---------------------------------------------------------------------
		// событие: изменились данные в Vuex об опциях пользователя
		//---------------------------------------------------------------------
		optionHandler() {
		},
		//---------------------------------------------------------------------
		// событие: скролл тела модального диалога
		//---------------------------------------------------------------------
		onModalBodyScroll(e) {
			if (!e || !e.target) return

			let $body = $(e.target)
			if (!$body.length) return

			// если есть скролл
			if ($body[0].scrollHeight <= $body[0].clientHeight) return

			let delta = $body[0].scrollHeight - $body[0].clientHeight
			if ($body[0].scrollTop <= 0)
			{
				$('#modal-scroll-arrow-up').hide()
				$('#modal-scroll-arrow-down').show()
			}
			else if ($body[0].scrollTop > 0 && $body[0].scrollTop < delta)
			{
				$('#modal-scroll-arrow-up').show()
				$('#modal-scroll-arrow-down').show()
			}
			else if ($body[0].scrollTop >= delta)
			{
				$('#modal-scroll-arrow-up').show()
				$('#modal-scroll-arrow-down').hide()
			}
		},
		//---------------------------------------------------------------------
		// событие: ресайз окна
		//---------------------------------------------------------------------
		onWindowResize() {
			// переопределяем переменную
			let vh = window.innerHeight * 0.01
			document.documentElement.style.setProperty('--vh', vh + 'px')

			// ищем активный диалог
			this.activeModalFindCounter = 0
			this.$nextTick(() => this.findActiveModal())
		},
		//---------------------------------------------------------------------
		// диалог требований к пользователю
		//---------------------------------------------------------------------
		// показ диалога
		showUserNeedDialog() {
			// запросим форму смены пароля
			let _url = Vue.APIServerUrl

			if (this.userNeedDialogMode === 'password')
			{
				if (this.$store.state.user_type === 'admin')
					_url += '/admin/password'
				else
					_url += '/user/password'
			}
			else _url += '/email/create'

			this.$http.get(_url)
			.then(ans => {
				let _dt = ans && ans.body && typeof ans.body === 'object' ? ans.body : false
				// если ошибки нет
				if (_dt && _dt['status'] === 'form' && _dt['fields'])
				{
					this.userNeedDialogTitle = _dt['title']
					this.fieldsUserNeed = this.parseFormData(_dt)
					this.$nextTick(() => {
						// просто показываем диалог
						EventBus.$emit('w5-body-scroll-disable')
						this.showUserNeedDialogModal = true
						this.$forceUpdate()
					})
				}
			})
			.catch(() => {})
		},
		// закрытие
		hideUserNeedDialogModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showUserNeedDialogModal = false
			this.hideModalMask()
		},
		// получить последнее поле
		userNeedLastField() {
			if (!this.fieldsUserNeed || !this.fieldsUserNeed.fields || !this.fieldsUserNeed.fields.length)
				return null

			let lastRow = null
			for (let i = this.fieldsUserNeed.fields.length - 1; i >= 0; i--)
			{
				lastRow = this.fieldsUserNeed.fields[i]
				if (lastRow && lastRow.length)
					break
			}
			if (!lastRow || !lastRow.length)
				return null

			return lastRow[lastRow.length - 1]
		},
		findField(name, fields) {
			// если нет вообще полей
			if (!fields || !fields.length) return null

			// поля есть - пробежимся по ним
			let _field = null
			fields.some(item => {
				if (item && Array.isArray(item))
				{
					item.some(obj => {
						if (obj && obj['_field_name'] === name)
						{
							_field = obj
							return true
						}
					})

					if (_field) return true
				}
			})

			return _field
		},
		// подтверждение формы
		submitUserNeedForm() {
			this.fieldEmailError = ''

			let lastField = this.userNeedLastField()
			if (!lastField) return

			// проверка прав доступа
			let _access = true
			if (this.userNeedDialogMode === 'password')
			{
				if (this.$store.state.user_type === 'admin')
					_access = this.isAccess('admin/options')
				else
					_access = this.isAccess('user/options')
			}
			else
			{
				_access = true
				lastField.required = false
			}

			// если доступа нет
			if (!_access)
			{
				lastField['_errMsg'] = 'main/access_denied'
				if (this.userNeedDialogMode !== 'password') this.fieldEmailError = lastField['_errMsg']
				return
			}

			// бежим по всем полям
			let _rows = this.fieldsUserNeed['fields']

			// если полей нет
			if (!_rows || !Array.isArray(_rows))
			{
				lastField['_errMsg'] = 'error/app_internal'
				if (this.userNeedDialogMode !== 'password') this.fieldEmailError = lastField['_errMsg']
				return
			}

			// проверка обязательных полей
			let _isErr = _rows.some(row => {
				let _found = false
				if (row && Array.isArray(row) && row.length)
				{
					_found = row.some(fld => {
						if (!fld['_visible']) return false
						// обязательное поле?
						if (fld['required'] === true && fld['type'] !== 'email')
						{
							// если значение вообще не задано
							if (fld.value === undefined || fld.value === null || String(fld.value) === '')
							{
								fld['_errMsg'] = 'error/required_field'
								return true
							}
						}
					})
				}

				if (_found) return true
			})
			if (_isErr) return

			lastField['_errMsg'] = ''
			let _data = this.collectFormData(_rows, this.verifyField)
			// если данные по каким либо причинам собрать не удалось
			if (_data === false) return

			// данные собраны - отправляем их
			let _url
			if (this.userNeedDialogMode === 'password')
			{
				if (this.$store.state.user_type === 'admin')
					_url = '/admin/password'
				else
					_url = '/user/password'
			}
			else _url = '/email/create'

			this.$http.get(this.APIServerUrl + _url)
			.then(resGet => {
				// получаем ответ
				let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
				// если ответ корректный
				if (_dt && _dt['status'] === 'form' && _dt['_csrf'] && _dt['model'])
					return { csrf: _dt['_csrf'], model: _dt['model'] }

				throw new Error(_dt)
			})
			.then(getDate => {
				_data = this.FormDataRePack(_data)

				// готовим данные
				let _post = {
					'_csrf': getDate.csrf
				}
				_post[getDate.model] = _data

				// готовим данные в виде FormData
				this.FD = new FormData()
				this.FD_count = 0
				this.FD_prepare(_post)

				// производим сам запрос
				this.$http.post(this.APIServerUrl + _url, this.FD_count > 0 ? this.FD : null).then(
					// успешный ответ сервера
					resPost => {
						// данные
						let _dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
						// если ошибки нет
						if (_dt && _dt['status'] === 'ok')
						{
							// можем закрыть диалог
							this.hideUserNeedDialogModal()
							// сообщение об успехе
							EventBus.$emit('w5-notificator-add', {
								'title': ' ',
								'message': _dt['title'],
								'class': 'success',
								'type': 'nourl',
								'id': 'success-message',
								'timeout': 3000
							})
							return
						}

						// если есть ошибки и поля
						if (_dt && _dt['status'] === 'error' && _dt['fields'])
						{
							let _txtError = ''
							// бежим по всем полям
							for (let k in _dt['fields'])
							{
								if (_dt['fields'][k] && Array.isArray(_dt['fields'][k]) && _dt['fields'][k].length)
								{
									// ищем поле, для которого указана ошибка
									let _fld = this.findField(k, _rows)
									// если такое поле есть - ставим все сообщения
									if (_fld)
									{
										_fld['_errMsg'] = this.localeFtc(_dt['fields'][k].join(' <br> '))
										if (this.userNeedDialogMode !== 'password' && _fld['_field_name'] === 'email') this.fieldEmailError = _fld['_errMsg']
										EventBus.$emit('w5-set-field-error')
									}
									else _txtError += this.localeFtc(_dt['fields'][k].join(' <br> '))
								}
							}
							if (_txtError)
							{
								lastField['_errMsg'] = _txtError
								if (this.userNeedDialogMode !== 'password') this.fieldEmailError = lastField['_errMsg']
							}
							// на этом все
							return
						}
						// иная ошибка
						lastField['_errMsg'] = this.formatRequestError(resPost)
						if (this.userNeedDialogMode !== 'password') this.fieldEmailError = lastField['_errMsg']
					},
					// отрицательный ответ сервера
					resPost => {
						lastField['_errMsg'] = this.formatRequestError(resPost)
						if (this.userNeedDialogMode !== 'password') this.fieldEmailError = lastField['_errMsg']
					}
				)
			})
			.catch(error => {
				lastField['_errMsg'] = this.formatRequestError(error)
				if (this.userNeedDialogMode !== 'password') this.fieldEmailError = lastField['_errMsg']
			})
		},
		// признак видимости поля
		isVisibleField(row) {
			// по умолчанию не видна
			let _answer = false
			// ищем любое поле с типом не "hidden"
			row.some((item, idx, arr) => {
				// если такое поле есть - значит строка должна быть видима
				if (item && item.type !== 'hidden' && item['_visible'] === true)
				{
					_answer = true
					return true
				}
			})

			// возвращаем результат
			return _answer
		},
		// blur
		onBlurInput(field) {
			// проверка поля
			this.verifyField(field)
		},
		// focus
		onFocusInput(field) {
			// чистим ошибку если есть
			field['_errMsg'] = ''
			if (this.userNeedDialogMode !== 'password') this.fieldEmailError = ''
		},
		verifyField(field) {
			// по умолчанию чистим сообщение об ошибке
			field['_errMsg'] = ''
			this.fieldEmailError = ''

			// если значение пустое или не задано - проверка не нужна
			if (field.value === undefined || field.value === null || String(field.value) === '') return true

			// проверяем только определенные типы
			// если поле невидно - то и проверять нет смысла, передаваться будет как есть
			if (!field['_visible']) return true

			// INTEGRE
			if (field.type === 'integer' || field.type === 'int')
			{
				// получим значение в виде строки
				let v = String(field.value).trim()
				// уберем пробелы
				v = v.replace(/ /g, '')
				// парсим в INT
				let r = parseInt(v)
				// если не удалось
				if (isNaN(r))
				{
					field['_errMsg'] = 'validators/error_int'
					if (this.userNeedDialogMode !== 'password') this.fieldEmailError = field['_errMsg']
					return false
				}

				// если значение не изменилось
				if (v === String(r)) return
				// значение изменилось
				field['_errMsg'] = 'validators/error_int'
				if (this.userNeedDialogMode !== 'password') this.fieldEmailError = field['_errMsg']
				return false
			}

			// FLOAT || MONEY
			if (field.type === 'float' || field.type === 'money')
			{
				// получим значение в виде строки
				let v = String(field.value).trim()
				// уберем пробелы
				v = v.replace(/ /g, '')
				// парсим в FLOAT
				let r = parseFloat(v)
				// если не удалось
				if (isNaN(r))
				{
					field['_errMsg'] = 'validators/error_float'
					if (this.userNeedDialogMode !== 'password') this.fieldEmailError = field['_errMsg']
					return false
				}

				// доп.проверка
				if (!Helper.isNumeric(String(r)))
				{
					// значение не число
					field['_errMsg'] = 'validators/error_float'
					if (this.userNeedDialogMode !== 'password') this.fieldEmailError = field['_errMsg']
					return false
				}
			}

			// EMAIL
			if (field.type === 'email')
			{
				if (Helper.validateEmail(field.value)) return true
				// проверка не пройдена
				field['_errMsg'] = 'validators/error_email'
				if (this.userNeedDialogMode !== 'password') this.fieldEmailError = field['_errMsg']
				return false
			}

			return true
		},
		// конвертация данных в FormData
		FD_prepare(d, key) {
			let k

			for (k in d) if (d.hasOwnProperty(k))
			{
				// если пересылают файл в форме - патч для safari 10+
				if (d[k] && key &&
					k === 'file' &&
					typeof d[k] === 'object' &&
					'name' in d[k] &&
					'size' in d[k] &&
					'type' in d[k])
				{
					this.FD.append(key + '[' + k + ']', d[k])
					this.FD_count++
					continue
				}

				// остальные поля обрабатываем по старому
				if (typeof d[k] === 'object' && d[k] && !('lastModifiedDate' in d[k]))
				{
					if (key)
					{
						this.FD_prepare(d[k], key + '[' + k + ']')
					}
					else
					{
						this.FD_prepare(d[k], k)
					}
				}
				else
				{
					if (key)
					{
						this.FD.append(key + '[' + k + ']', d[k])
					}
					else
					{
						this.FD.append(k, d[k])
					}

					this.FD_count++
				}
			}
		},
		// отправка задания планировщику
		startCronTask(inputData) {
			this.workerCron.postMessage(inputData)
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// событие: создание главного компонента приложения APP
	// по сути дела - это старт приложения
	//=========================================================================
	created() {
		// изменение опций пользователя на сервере - здесь ловим, что бы
		// при старте приложения получать значения
		EventBus.$on('w5-user-options-on-server', this.optionHandler)

		// обработчик событий localStorage
		this.$store.commit('currentAppId')

		const _limit = this.AppName === 'vdsina.com' ? 100 : 10000
		this.$store.commit('setOperationSumNew', _limit)

		// дополнительная функция для "showif"
		if (!window.w5InArray)
			window.w5InArray = function(variable, array) {
				let _answer = -1
				array.some((item, idx) => {
					if (String(item) === String(variable))
					{
						_answer = idx
						return true
					}
				})
				return _answer
			}

		// дополнительная функция - глубокое копирование объекта
		if (!window.ObjDeepClone)
			window.ObjDeepClone = function(src) {
				return JSON.parse(
					JSON.stringify(src)
				)
			}

		// проверим работу с веб-воркерами
		this.startWorkers()
		// проверим работу с хранилищем
		.then(this.initStorage)
		// аутентификация пользователя
		.then(this.authUser)
		// операция при успешном входе
		.then(this.successLogin)
		// если появилась какая то ошибка
		.catch(this.onErrorInitApp)

		// функция обработки скролла тела модального диалога
		this.onModalBodyScroll = debounce(this.onModalBodyScroll, 500)
		// функция обработки ресайза окна
		//this.onWindowResize = debounce(this.onWindowResize, 500)
	},
	//=========================================================================
	// обработчик: компонент примонтирован в DOM
	//=========================================================================
	mounted() {
		// навешиваем обработчик для проверки активности
		document.addEventListener('mousemove', this.dropBlocker)
		document.addEventListener('keydown', this.dropBlocker)
		document.addEventListener('scroll', this.dropBlocker)
		window.addEventListener('resize', this.onWindowResize)
		EventBus.$on('w5-body-scroll-disable', this.disableScroll)
		EventBus.$on('w5-body-scroll-enable', this.enableScroll)
		EventBus.$on('w5-push', this.pushMessageHandler)
		EventBus.$on('w5-cron-task-start', this.startCronTask)
		EventBus.$on('w5-on-lang', this.handleLang)

		// получим элемент "audio"
		this.audio = this.$refs['audioBlock']
		if (this.audio) this.audio.addEventListener('canplay', this.audioCanPlay)
	},
	//=========================================================================
	// обработчик: перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// удалим обработчик для проверки активности
		document.removeEventListener('mousemove', this.dropBlocker)
		document.removeEventListener('keydown', this.dropBlocker)
		document.removeEventListener('scroll', this.dropBlocker)
		window.removeEventListener('resize', this.onWindowResize)
		EventBus.$off('w5-body-scroll-disable', this.disableScroll)
		EventBus.$off('w5-body-scroll-enable', this.enableScroll)
		EventBus.$off('w5-push', this.pushMessageHandler)
		EventBus.$off('w5-user-options-on-server', this.optionHandler)
		EventBus.$off('w5-cron-task-start', this.startCronTask)
		EventBus.$off('w5-on-lang', this.handleLang)

		delete window.w5InArray
		window.w5InArray = null

		if (this.audio) this.audio.removeEventListener('canplay', this.audioCanPlay)

		if (this.activeModalFindTimer) clearTimeout(this.activeModalFindTimer)
	},
	//=========================================================================
	// наблюдаем переходы между CRUD внутри одного и того же компонента
	//=========================================================================
	watch: {
		'$store.state.is_auth': function(value) {
			if (value)
			{
				// пользователь аутентифицирован
				// старт PUSH-системы
				this.$store.commit('pushStart')
				// старт блокиратора
				if (this.workerVersion) this.workerVersion.postMessage('startBlocker')
				// первоначальный запрос счетчиков тикетов
				this.$store.dispatch('getTicketCounters')
				// первоначальный запрос счетчика активных заявок
				this.$store.dispatch('getRequestCounter')
			}
			else
			{
				// пользователь НЕ аутентифицирован
				// остановим Push-систему
				this.$store.commit('pushStop')
				// остановить блокиратор
				if (this.workerVersion) this.workerVersion.postMessage('stopBlocker')
				if (this.workerCron) this.workerCron.postMessage('stop')
			}
		},
		'$route': function(to, from) {
			// получим путь
			let _path = null
			if (to && to.path)
				_path = String(to.path)

			// если это оплаты клиентом
			if (this.$store.state.is_auth && this.$store.state.user_type === 'client' &&
				_path && _path.length &&
				(_path.indexOf('/operation/create') === 0 || _path.indexOf('/operation/select') === 0 ||
				_path.indexOf('/operation/pay') === 0))
			{
				// шлем данные в google analitics
				if (window && window.gtag)
					window.gtag('config', 'UA-31804196-2')
			}
			// обнуляем флаг измененной формы
			this.$store.commit('changedForm', false)
		},
		'pageTitle': function() {
			// заголовок страницы
			document.title = this.localeFtc(this.pageTitle)
		}
	}

	//=========================================================================
}
</script>

<style src="./assets/flags/css/flag-icon.min.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="./style.css"></style>



// WEBPACK FOOTER //
// App.vue?e937ed64